<template>
  <div class="title_wrapper">
    <div class="title">
      <slot name="title"></slot>
    </div>
    <div class="sub-title">
      <slot name="sub_title"></slot>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.title_wrapper {
  padding-left: 8px;
  border-left: 2px solid rgb(7, 124, 172);
  .title {
    font-size: 18px;
    font-weight: bold;
    color: #434355;
    line-height: 1;
    padding-bottom: 2px;
  }
  .sub-title {
    font-size: 12px;
    font-weight: bold;
    color: #878799;
    line-height: 1;
  }
}
</style>
